import { Group } from '@mantine/core'
import { ReactComponent as COLLAPSEDLOGO } from '../../../styles/LENDOS-CollapsedLogo.svg'

export const CustomLoader = () => {
  return (<div className="loaderWrapper">
    <div className='loading' />
    <COLLAPSEDLOGO className="loaderLogo" />
  </div >)
}

/** The loader centred in whatever holds it (a modal body while its reads land), not pinned to the left. */
export const CenteredLoader = () => (
  <Group position="center" py="xl">
    <CustomLoader />
  </Group>
)
